import { MessageChannels } from "../message";
export var SDQueryTimeRange;
(function (SDQueryTimeRange) {
    SDQueryTimeRange["OneHour"] = "OneHour";
    SDQueryTimeRange["TwoHours"] = "TwoHours";
    SDQueryTimeRange["ThreeHours"] = "ThreeHours";
    SDQueryTimeRange["SixHours"] = "SixHours";
    SDQueryTimeRange["TwelveHours"] = "TwelveHours";
    SDQueryTimeRange["OneDay"] = "OneDay";
    SDQueryTimeRange["TwoDays"] = "TwoDays";
    SDQueryTimeRange["ThreeDays"] = "ThreeDays";
    SDQueryTimeRange["FourDays"] = "FourDays";
    SDQueryTimeRange["FiveDays"] = "FiveDays";
    SDQueryTimeRange["SixDays"] = "SixDays";
    SDQueryTimeRange["SevenDays"] = "SevenDays";
})(SDQueryTimeRange || (SDQueryTimeRange = {}));
export var SDQueryEventState;
(function (SDQueryEventState) {
    SDQueryEventState["Live"] = "Live";
    SDQueryEventState["PreLive"] = "PreLive";
    SDQueryEventState["Mixed"] = "Mixed";
})(SDQueryEventState || (SDQueryEventState = {}));
export var SDQueryEventTags;
(function (SDQueryEventTags) {
    SDQueryEventTags["LiveStreaming"] = "LiveStreaming";
    SDQueryEventTags["FastMarket"] = "FastMarket";
    SDQueryEventTags["Stats"] = "Stats";
})(SDQueryEventTags || (SDQueryEventTags = {}));
export var SDQueryLeagueState;
(function (SDQueryLeagueState) {
    SDQueryLeagueState["Regular"] = "Regular";
    SDQueryLeagueState["Mixed"] = "Mixed";
})(SDQueryLeagueState || (SDQueryLeagueState = {}));
export var SDQueryMarketTypeRequestStatement;
(function (SDQueryMarketTypeRequestStatement) {
    SDQueryMarketTypeRequestStatement["Include"] = "Include";
    SDQueryMarketTypeRequestStatement["Exclude"] = "Exclude";
})(SDQueryMarketTypeRequestStatement || (SDQueryMarketTypeRequestStatement = {}));
export var SDQueryEventTypes;
(function (SDQueryEventTypes) {
    SDQueryEventTypes["Fixture"] = "Fixture";
    SDQueryEventTypes["Outright"] = "Outright";
    SDQueryEventTypes["AntePostRace"] = "AntePostRace";
    SDQueryEventTypes["AggregateFixture"] = "AggregateFixture";
})(SDQueryEventTypes || (SDQueryEventTypes = {}));
export const SDQuery_Types = MessageChannels;
//# sourceMappingURL=sports.js.map